export default {
      id: "icon-icon_filled-usage",
      viewBox: "0 0 29.73 29.88",
      url: __webpack_public_path__ + "icons.svg#icon-icon_filled",
      toString: function () {
        return this.url;
      }
    }